"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgLevelIndicator3Outline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.level-indicator-3_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "level-indicator-3_outline_svg__transparent_box" },
            React.createElement("path", { className: "level-indicator-3_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "level-indicator-3_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "level-indicator-3_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M2.99 16h2v12h-2zM10.99 12h2v16h-2zM18.99 8h2v20h-2z" }))));
}
exports.default = SvgLevelIndicator3Outline;
//# sourceMappingURL=LevelIndicator3Outline.js.map